import { DataTable } from '@/components/common/DataTable';
import { EditTableModal } from '@/components/common/EditTableModal';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { GameTable } from '@/types';
import { ColumnDef } from '@tanstack/react-table';
import { MoreHorizontal } from 'lucide-react';
import { useState } from 'react';

export function TableList() {
  const [tableData, setTableData] = useState<GameTable[]>([
    {
      id: 'TBL1001',
      tableName: 'Dragon Arena 1',
      betType: 'Dragon',
      minBet: 10,
      maxBet: 5000,
      status: 'Active',
      playersOnline: 23,
      roundTime: 15,
      createdAt: '2025-02-22T09:40:00Z',
      updatedAt: '',
    },
  ]);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [selectedTable, setSelectedTable] = useState<GameTable | null>(null);

  // const handleEdit = (row: GameTable) => {
  //   setOpenModal(true)
  //   setSelectedTable(row)
  // }

  // const handleCancel = () => {
  //   setOpenModal(false)
  //   setSelectedTable(null)
  // }

  const changeStatus = (newStatus: GameTable['status'], id: string) => {
    setTableData((prev) =>
      prev.map((table) => (table.id === id ? { ...table, status: newStatus } : table))
    );
  };

  const tableColumns: ColumnDef<GameTable>[] = [
    {
      accessorKey: 'id',
      header: 'Table ID',
    },
    {
      accessorKey: 'tableName',
      header: 'Table Name',
    },
    {
      accessorKey: 'betType',
      header: 'Bet Type',
      cell: ({ row }) => {
        const t = row.original.betType;
        return <span>{t}</span>;
      }, // static for all rows
    },
    {
      accessorKey: 'betLimits',
      header: 'Min / Max Bet',
      cell: ({ row }) => {
        const { minBet, maxBet } = row.original;
        return (
          <span>
            ₹{minBet} / ₹{maxBet}
          </span>
        );
      },
    },
    {
      accessorKey: 'status',
      header: 'Status',
      cell: ({ row }) => {
        const s = row.original.status;

        const color =
          s === 'Active' ? 'text-green-500' : s === 'Stopped' ? 'text-red-500' : 'text-yellow-500';

        return <span className={color}>{s}</span>;
      },
    },
    {
      accessorKey: 'playersOnline',
      header: 'Players Online',
    },
    {
      accessorKey: 'roundTime',
      header: 'Round Time (Sec)',
    },
    {
      accessorKey: 'createdAt',
      header: 'Created',
      enableHiding: true,
    },
    {
      accessorKey: 'action',
      header: 'Actions',
      cell: ({ row }) => {
        const item = row.original;
        return (
          <DropdownMenu>
            <DropdownMenuTrigger>
              <MoreHorizontal />
            </DropdownMenuTrigger>
            <DropdownMenuContent>
              {/* <DropdownMenuItem onClick={() => handleEdit(item)}>
                Edit
              </DropdownMenuItem> */}
              {row.original.status === 'Active' ? (
                <DropdownMenuItem onClick={() => changeStatus('Paused', item.id)}>
                  Pause
                </DropdownMenuItem>
              ) : (
                <DropdownMenuItem onClick={() => changeStatus('Active', item.id)}>
                  Start
                </DropdownMenuItem>
              )}
            </DropdownMenuContent>
          </DropdownMenu>
        );
      },
    },
  ];

  return (
    <div className="relative">
      <div className="flex items-center justify-between mb-10">
        <div>
          <h2 className="text-3xl font-bold tracking-tight">Game Tables</h2>
          <p className="text-muted-foreground">
            Manage all active and inactive game tables. View table performance, player activity,
            round timing, and modify table configurations such as limits and status.
          </p>
        </div>
      </div>
      <DataTable
        columns={tableColumns}
        data={tableData}
        pageIndex={0}
        total={0}
        onPageChange={function (page: number): void {
          throw new Error('Function not implemented.');
        }}
        onPageSizeChange={function (size: number): void {
          throw new Error('Function not implemented.');
        }}
      />
      {/* {
        openModal && (
          <div className="absolute top-0 left-0 w-full h-screen bg-muted">
            <EditTableModal cancelEdit={handleCancel} data={selectedTable} />
          </div>
        )
      } */}
    </div>
  );
}
